export const getFormFieldData = async (fieldName: string, data: object | undefined): Promise<unknown> => {
  if (!data) return undefined;

  const fieldNameArray = fieldName.split('.');
  return getRecursiveKey(data, fieldNameArray);
};

const getRecursiveKey = async (object: object, array: string[]): Promise<unknown> => {
  if (array.length > 1) {
    const newObject = object[array.shift() as string];
    if (!newObject) return undefined;
    return await getRecursiveKey(newObject, array);
  }
  return object[array[0]];
};
